import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFDelta2VideoPlayer from '@/components/UI/svg/Delta2/Icon/EFDelta2VideoPlayer';
import EFVideoModal from '@/components/UI/EFVideoModal';
import NextImage from '@/components/NextImage';
import { subscribeShopify } from '@/service';
import { Upto1 } from '@/components/UI/svg/Wave2';

const Icon = () => (
    <svg className="email-icon" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.6657 3.76428H4.73322C3.87663 3.76428 3.16411 4.04192 2.59564 4.59719C2.02718 5.15247 1.74295 5.8353 1.74295 6.64571V18.1714C1.74295 18.9968 2.02718 19.6834 2.59564 20.2312C3.16411 20.7789 3.87663 21.0528 4.73322 21.0528H20.6657C21.5223 21.0528 22.2348 20.7789 22.8033 20.2312C23.3718 19.6834 23.656 18.9968 23.656 18.1714V6.64571C23.656 5.8353 23.3718 5.15247 22.8033 4.59719C22.2348 4.04192 21.5223 3.76428 20.6657 3.76428ZM4.73322 5.70024H20.6657C20.8682 5.70024 21.0434 5.74526 21.1914 5.8353C21.3393 5.92535 21.4678 6.06792 21.5768 6.26302L12.6995 12.2285L3.82212 6.26302C3.93114 6.06792 4.05963 5.92535 4.20758 5.8353C4.35554 5.74526 4.53075 5.70024 4.73322 5.70024ZM20.6657 19.1394H4.73322C4.42173 19.1394 4.17644 19.0531 3.99733 18.8805C3.81822 18.7079 3.72867 18.4715 3.72867 18.1714V8.4691L12.0921 14.1419C12.2011 14.1869 12.3062 14.232 12.4075 14.277C12.5087 14.322 12.606 14.3445 12.6995 14.3445C12.7929 14.3445 12.8903 14.322 12.9915 14.277C13.0927 14.232 13.1978 14.1869 13.3069 14.1419L21.6703 8.4691V18.1714C21.6703 18.4715 21.5807 18.7079 21.4016 18.8805C21.2225 19.0531 20.9772 19.1394 20.6657 19.1394Z"
            fill="#919191"
        />
    </svg>
);

export default function A() {
    const { useLang, useRouter, gtm, getSystemTime } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const { locale, query } = useRouter();
    const viewportRef: any = useRef(null);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const NA_SITES = ['us', 'ca', 'br', 'mx'];
    const LaunchTimer = query?.timer ? new Date(`${query?.timer} GMT+8`).getTime() : new Date('2024/04/24 15:00:00 GMT+8').getTime();
    const sysTime = getSystemTime();
    const nowTime = sysTime <= 1000000 ? new Date().getTime() : sysTime;
    const [showMsg, setShowMsg] = useState('');
    const [input, setInput] = useState('');

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/mVy4qDIqNnE',
        cn: {
            SD: 'https://videos.ecoflow.com/1a392d00e3d471edb59d7630a6ac0102/d0e9031f4e0f57a09fc27c9ac25549c8-ld.mp4',
            HD: 'https://videos.ecoflow.com/1a392d00e3d471edb59d7630a6ac0102/f8a0c9b9fdefed52f5dedf8a3daa877e-sd.mp4',
            '2K': 'https://videos.ecoflow.com/1a392d00e3d471edb59d7630a6ac0102/507704b705d1baaf565d6981f3e50189-hd.mp4',
        },
    };

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.mask', { y: 0 }, { y: -200 }]],
            triggerElement: '.viewport-wrapper',
            triggerHook: 0,
            offset: 0,
            duration: '20%',
        });
    }, []);

    const playerVideo = () => {
        setShowEFVideoModal(true);
        const isBird = !!document.querySelector('.crowdfunding-tabs-nav');
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow WAVE 2 | UX video',
            position: isBird ? 'Product_1' : 'Product Detail_1',
        });
    };

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        if (showMsg) {
            setShowMsg('');
        }
    };

    const handleSubmit = async () => {
        const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(input)) {
            setShowMsg(t('wave2inputerror'));
            setTimeout(() => {
                setShowMsg('');
            }, 3000);
            return;
        }
        // 订阅SMS
        const dataSMS = {
            email: input.trim(),
            contactListId: '2025225755',
            fields: [],
        };
        try {
            const res = await subscribeShopify(dataSMS, locale, {
                sector_name: t('wave2'),
                entry_position: 2,
            });
            if (res?.code === '0') {
                setInput('');
                setShowMsg(t('wave2success'));
                setTimeout(() => {
                    setShowMsg('');
                }, 3000);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('wave2subscribe'),
                    status: 'success',
                    tag: 'None',
                });
            } else {
                setShowMsg(res?.message);
                setTimeout(() => {
                    setShowMsg('');
                }, 3000);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('wave2subscribe'),
                    status: 'fail',
                    tag: 'None',
                });
            }
        } catch (e) {
            setShowMsg(e);
            setTimeout(() => {
                setShowMsg('');
            }, 3000);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('wave2subscribe'),
                status: 'fail',
                tag: 'None',
            });
        }
    };

    return (
        <div className={`wave2-detail-A ${css.wave2DetailA}`}>
            <div className={`img-wrapper`}>
                <NextImage
                    webpSrc={require(NA_SITES.includes(locale) ? '@publicLocal/wave2/detail/kv_na_pc.jpg' : '@publicLocal/wave2/kv-pc-1.webp')}
                    src={require(NA_SITES.includes(locale) ? '@publicLocal/wave2/detail/kv_na_pc.jpg' : '@publicLocal/wave2/kv-pc-1.jpg')}
                    alt={t('wave2')}
                    aria-label={t('wave2')}
                    priority={true}
                    quality={50}
                />
            </div>
            <div className={`viewport-wrapper`} ref={viewportRef}>
                {NA_SITES.includes(locale) && nowTime < LaunchTimer && <p className="date">{t('wave2date')}</p>}
                <p className="wave2">{t('wave2')}</p>
                <p className="slogan">{t('wave2slogan')}</p>
                {!NA_SITES.includes(locale) && (
                    <p className="video-btn" onClick={() => playerVideo()}>
                        <span className="text">{t('detail.video_btn')}</span>
                        <span className="btn">
                            <EFDelta2VideoPlayer fillColor="#000" />
                        </span>
                    </p>
                )}
                {NA_SITES.includes(locale) && !['br', 'mx'].includes(locale) && (
                    <>
                        <div className="control">
                            <div className="input-box">
                                <input type="text" className="input" value={input} onChange={handleInputChange} placeholder={t('wave2placeholder')} />
                                <Icon />
                                {nowTime < LaunchTimer && <Upto1 off={locale === 'ca' ? '27' : '40'} text="Up To" className="off-icon" />}
                            </div>
                            <button className="subscribe" onClick={handleSubmit}>
                                {t('wave2subscribe')}
                            </button>
                        </div>
                        {showMsg && <p className={`error-msg ${t('wave2success') === showMsg ? 'success' : ''}`}>{showMsg}</p>}
                    </>
                )}
            </div>
            <div className="mask"></div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
